import { forceLogin } from "src/model/services/profile.service";

export const checkUserLogged = (e) => {
    if (e?.response?.status === 403 || e?.response?.status === 401) {
        forceLogin();
        throw e;
    }
}